var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.75006 1.5C2.06428 1.5 1.50006 2.06421 1.50006 2.75V14.75C1.50006 15.4358 2.06428 16 2.75006 16H18.75C19.4358 16 20 15.4358 20 14.75V2.75C20 2.06421 19.4358 1.5 18.75 1.5H2.75006ZM6.10327e-05 2.75C6.10327e-05 1.23579 1.23585 0 2.75006 0H18.75C20.2643 0 21.5 1.23579 21.5 2.75V14.75C21.5 16.2642 20.2643 17.5 18.75 17.5H2.75006C1.23585 17.5 6.10327e-05 16.2642 6.10327e-05 14.75V2.75Z",
    fill: "#007191"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.135642 2.3199C0.373172 1.98057 0.840822 1.89804 1.18016 2.13558L10.75 8.8345L20.3199 2.13558C20.6593 1.89804 21.1269 1.98057 21.3645 2.3199C21.602 2.65924 21.5195 3.12689 21.1801 3.36442L11.1801 10.3644C10.9219 10.5452 10.5782 10.5452 10.3199 10.3644L0.319972 3.36442C-0.0193678 3.12689 -0.101898 2.65924 0.135642 2.3199Z",
    fill: "#007191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterIcon);
export default __webpack_public_path__ + "static/media/letter_icon.7de0f469d6580ab34a1fe91e2330a120.svg";
export { ForwardRef as ReactComponent };